import React from 'react';

import MContactAddress from '../../molecules/contact/_molecules.contact-address';
import MContactInfo from '../../molecules/contact/_molecules.contact-info';

export default function OContactInfo({ children }) {
	return (
		<section className="o-section-contact-info">
			<div className="o-section-contact-info--form">
				{children}
			</div>
			<div className="o-section-contact-info--wrapper">
				<MContactAddress className="t-gap--bottom-lg" />
				<MContactInfo />
			</div>
		</section>
	);
}



// WEBPACK FOOTER //
// ./src/components/organisme/contact/_organisme.contact-info.js